import { useState, useEffect, useRef } from "react";
import { markNotifsRead } from "../../utils/notifications";

export function NotificationBell({ userId, data, onDataChange }) {
  const [open, setOpen] = useState(false);
  const panelRef = useRef();
  const myNotifs = (data.notifications || []).filter(n => n.userId === userId).sort((a,b) => b.date - a.date).slice(0, 20);
  const unread = myNotifs.filter(n => !n.read).length;

  useEffect(() => {
    if (!open) return;
    const updated = markNotifsRead(data, userId);
    onDataChange(updated);
    function handleClick(e) { if (panelRef.current && !panelRef.current.contains(e.target)) setOpen(false); }
    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, [open]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div ref={panelRef} style={{ position: "relative" }}>
      <button onClick={() => setOpen(o => !o)}
        style={{ background: "none", border: "none", cursor: "pointer", fontSize: "1.35rem", position: "relative", padding: ".2rem .35rem", borderRadius: 10, lineHeight: 1 }}>
        🔔
        {unread > 0 && (
          <span style={{ position: "absolute", top: -2, right: -4, background: "var(--red)", color: "#fff", fontSize: ".6rem", fontWeight: 800, padding: ".1rem .35rem", borderRadius: 999, minWidth: 16, textAlign: "center" }}>
            {unread > 9 ? "9+" : unread}
          </span>
        )}
      </button>
      {open && (
        <div style={{ position: "absolute", top: "110%", right: 0, zIndex: 300, width: 300, background: "var(--surface)", border: "1px solid var(--border)", borderRadius: 14, boxShadow: "0 8px 32px rgba(0,0,0,.15)", overflow: "hidden" }}>
          <div style={{ padding: ".75rem 1rem", borderBottom: "1px solid var(--border)", fontWeight: 800, fontSize: ".88rem", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <span>🔔 Notifications</span>
            {myNotifs.length > 0 && <button onClick={() => { onDataChange({ ...data, notifications: (data.notifications||[]).filter(n => n.userId !== userId) }); setOpen(false); }}
              style={{ background: "none", border: "none", cursor: "pointer", fontSize: ".72rem", color: "var(--muted)" }}>Clear all</button>}
          </div>
          {myNotifs.length === 0
            ? <div style={{ padding: "1.25rem 1rem", color: "var(--muted)", fontSize: ".85rem", textAlign: "center" }}>No notifications yet</div>
            : <div style={{ maxHeight: 320, overflowY: "auto" }}>
                {myNotifs.map(n => (
                  <div key={n.id} style={{ padding: ".7rem 1rem", borderBottom: "1px solid var(--border)", background: n.read ? "transparent" : "var(--blue-light)", display: "flex", gap: ".65rem", alignItems: "flex-start" }}>
                    <div style={{ fontSize: "1.3rem", flexShrink: 0 }}>{n.icon}</div>
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div style={{ fontWeight: 700, fontSize: ".83rem", color: "var(--ink)" }}>{n.title}</div>
                      <div style={{ fontSize: ".75rem", color: "var(--muted)", marginTop: ".1rem" }}>{n.body}</div>
                      <div style={{ fontSize: ".68rem", color: "var(--muted)", marginTop: ".2rem" }}>{new Date(n.date).toLocaleDateString("en-AU", { day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" })}</div>
                    </div>
                  </div>
                ))}
              </div>
          }
        </div>
      )}
    </div>
  );
}
